import React from "react";

const parseInline = (text) => {
  const parts = [];
  const pattern = /(\*\*[^*]+\*\*|_[^_]+_)/g;
  let lastIndex = 0;
  let match;

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const token = match[0];
    if (token.startsWith("**")) {
      parts.push(<strong key={`${match.index}-bold`}>{token.slice(2, -2)}</strong>);
    } else {
      parts.push(<em key={`${match.index}-italic`}>{token.slice(1, -1)}</em>);
    }
    lastIndex = match.index + token.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length ? parts : text;
};

const flushList = (items, ordered, elements) => {
  if (!items.length) return;
  const ListTag = ordered ? "ol" : "ul";
  elements.push(
    <ListTag key={`list-${elements.length}`} className="mb-2 ps-4">
      {items.map((item, index) => (
        <li key={index}>{parseInline(item)}</li>
      ))}
    </ListTag>
  );
};

export default function TaskDescriptionView({ text, preview = false }) {
  const content = String(text || "").trim();

  if (!content) {
    return <span className="text-muted">No description</span>;
  }

  const lines = content.split(/\r?\n/);
  const elements = [];
  let listItems = [];
  let listOrdered = false;

  lines.forEach((line, index) => {
    const trimmed = line.trim();

    if (!trimmed) {
      flushList(listItems, listOrdered, elements);
      listItems = [];
      return;
    }

    const heading = trimmed.match(/^#{1,3}\s+(.+)$/);
    const bullet = trimmed.match(/^[-*]\s+(.+)$/);
    const numbered = trimmed.match(/^\d+[.)]\s+(.+)$/);

    if (heading) {
      flushList(listItems, listOrdered, elements);
      listItems = [];
      elements.push(
        <div key={`heading-${index}`} className="fw-semibold mb-1">
          {parseInline(heading[1])}
        </div>
      );
      return;
    }

    if (bullet || numbered) {
      const isOrdered = Boolean(numbered);
      if (listItems.length && listOrdered !== isOrdered) {
        flushList(listItems, listOrdered, elements);
        listItems = [];
      }
      listOrdered = isOrdered;
      listItems.push((bullet || numbered)[1]);
      return;
    }

    flushList(listItems, listOrdered, elements);
    listItems = [];
    elements.push(
      <p key={`paragraph-${index}`} className="mb-2">
        {parseInline(trimmed)}
      </p>
    );
  });

  flushList(listItems, listOrdered, elements);

  return (
    <div className={preview ? "small task-description-preview" : "task-description-view"}>
      {elements}
    </div>
  );
}
